export default {
    searchList: {
        searchTxt: [],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        selectBtn: false,
        clickState: false,
        leftOperation: false,
        height: 300,
        columns: [
            {
                label: '接口编码',
                prop: 'logCode',
                width: 100
            },
            {
                label: '接口名称',
                prop: 'apiName',
                width: 100
            },
            {
                label: '调用异常类型',
                prop: 'excType',
                width: 100
            },
            {
                label: '调用异常原因',
                prop: 'excDesc',
                width: 100
            },
            {
                label: '创建时间',
                prop: 'createTime',
                width: 100
            },
            {
                label: '更新时间',
                prop: 'updateTime',
                width: 100
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 50, 100]
    },
    showPage: true
};
